<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <account-overview type="year" title="Time Period" />
      </v-col>
      <v-col cols="12" md="6">
        <reporting-period period="yearly" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <campaign-tracking :items="yearlyStatistics.campaignTracking" />
      </v-col>
      <v-col cols="12">
        <click-breakdown :items="yearlyStatistics.clickBreakdown" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AccountOverview from '@/components/Affiliates/Statistics/AccountOverview'
import ReportingPeriod from '@/components/Affiliates/Statistics/ReportingPeriod'
import CampaignTracking from '@/components/Affiliates/Statistics/CampaignTracking'
import ClickBreakdown from '@/components/Affiliates/Statistics/ClickBreakdown'

export default {
  name: 'YearlyReport',
  components: {
    AccountOverview,
    ReportingPeriod,
    CampaignTracking,
    ClickBreakdown,
  },
  computed: mapGetters({
    yearlyStatistics: 'affiliates/yearlyStatistics'
  }),
  methods: mapActions({
    getYearlyStatistics: 'affiliates/getYearlyStatistics',
    reportError: 'reportError'
  }),
  async mounted () {
    try {
      await this.getYearlyStatistics()
    } catch (e) {
      this.reportError(e)
    }
  }
}
</script>

<style scoped>

</style>
